// removed by extract-text-webpack-plugin
module.exports = {"subForm":"OBkKDzalKBKx9HVjvX5uf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SubForm/index.less
// module id = 764
// module chunks = 0